import React, { useState } from "react";
import { Link } from "react-router-dom";
import { loginUser } from "../../api/auth";
import "../styles/TwentyTwentysixLogin.css";

export default function LoginPage() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await loginUser(formData);
      window.location.href = "/dashboard";
    } catch (err) {
      setError("Invalid email or password");
    }
    setLoading(false);
  };

  return (
    <div className="twentytwentysix-login">
      <div className="twentytwentysix-login__container">
        <div className="twentytwentysix-login__card">
          <h1 className="twentytwentysix-login__title">Login</h1>
          <p className="twentytwentysix-login__subtitle">Welcome back to The Mamahood</p>
          <p className="twentytwentysix-login__hint">
            New here? Head over to the <Link to="/signup">sign up</Link> page first.
          </p>

          <div className="twentytwentysix-login__divider" />

          <h2 className="twentytwentysix-login__section-title">Social accounts</h2>
          <ul className="twentytwentysix-login__social-list">
            <li>
              <a
                href="/api/auth/google"
                className="twentytwentysix-login__social-btn twentytwentysix-login__social-btn--google"
              >
                Login with Google
              </a>
            </li>
            <li>
              <a
                href="/api/auth/facebook"
                className="twentytwentysix-login__social-btn twentytwentysix-login__social-btn--facebook"
              >
                Login with Facebook
              </a>
            </li>
          </ul>

          <div className="twentytwentysix-login__divider" />

          <h2 className="twentytwentysix-login__section-title">The classic way</h2>
          {error && <div className="twentytwentysix-login__error" role="alert">{error}</div>}
          <form onSubmit={handleSubmit} className="twentytwentysix-login__form">
            <div className="twentytwentysix-login__field">
              <label htmlFor="twentytwentysix-login-email" className="twentytwentysix-login__label">
                Email
              </label>
              <input
                id="twentytwentysix-login-email"
                type="email"
                className="twentytwentysix-login__input"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                autoComplete="email"
              />
            </div>
            <div className="twentytwentysix-login__field">
              <label htmlFor="twentytwentysix-login-password" className="twentytwentysix-login__label">
                Password
              </label>
              <input
                id="twentytwentysix-login-password"
                type="password"
                className="twentytwentysix-login__input"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                autoComplete="current-password"
              />
            </div>
            <button
              type="submit"
              className="twentytwentysix-login__submit"
              disabled={loading}
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <div className="twentytwentysix-login__links">
            <Link to="/reset-password" className="twentytwentysix-login__link">
              Forgot password?
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
